/* eslint-disable import/prefer-default-export */
import { promisifiedDOMListener } from '@utils/async';

/**
 * * Asynchronous Navigation
 *
 * @description
 * This function navigates to a new URL asynchronously.
 *
 * @param {string} url
 * @param {Window} [$window=window]
 */
export const asyncNavigation = async (url, $window = globalThis.window) => { // eslint-disable-line no-undef
  $window.location.href = url;

  await promisifiedDOMListener('beforeunload');
};
